import { PopupStatus } from '@/components/Checkout/PopupStatus'
import React from 'react'

export const PaymentResult = () => {
  return (
    <PopupStatus
      icon="/img/error-icon.png"
      class="!bg-transparent !p-0 !overflow-hidden in-iframe"
      title="There was an error processing your payment information."
    />
  )
}
